<template>
    <modal name="mail-member-modal" class="mail-member-modal"
           :width="`50%`"
           :height="920"
           @before-open="handlerBeforeOpen"
           @before-close="handlerBeforeClose"
    >
        <div class="modal_filter_wrap">
            <member-list-modal-component :member-type="'memberMail'" :langOption="langOption"></member-list-modal-component>
            <div class="text-center mt10">
                <el-button class="reg_btn_out" @click="addMember(memberList)">선택항목 추가</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import MemberListModalComponent from "../member/MemberListModalComponent";
import EventBus from "@/utils/event-bus";

export default {
    name: "MailMemberModal",
    mixins: [],
    components: {
        MemberListModalComponent,
    },
    props: {},
    data() {
        return {
            memberList: [],
            langOption:'',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        EventBus.$on('setMemberData', this.setData);
    },
    beforeDestroy() {
        EventBus.$off('setMemberData');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        backEvent() {
            this.$modal.hide('mail-member-modal');
        },
        handlerBeforeOpen(event) {
            this.memberList = event.params.memberList;
            this.langOption = event.params.langOption;
        },
        handlerBeforeClose() {
            this.$router.replace(this.$route.path);
        },
        addMember(list) {
            EventBus.$emit('addMemberList', list);
            this.backEvent();
        },
        setData(value) {
            this.memberList = value;
        },
        changeMember(data) {
            this.$router.replace(this.$route.path);
            this.selectType = '';
            this.$nextTick(() => {
                this.selectType = this.searchOption;
            })

        },
    },
    watch: {},
}
</script>

<style scoped>

</style>